const gaTags = {
    "googleAnalyticsId.prod": "GTM-WR3QWR",
    "googleAnalyticsId.dev": "GTM-MBZH2H"
};
export default gaTags;
